import { Button } from '../../components/Button/Button.js';
import { SourceLabel } from '../../components/SourceLabel/SourceLabel.js';
import { StatusBadge } from '../../components/StatusBadge/StatusBadge.js';
import styles from './ChartHeader.module.css';

export function ChartHeader({
  title,
  subtitle,
  source,
  status = 'fresh',
  onExplain,
  onViewData,
  onViewSources,
}: {
  title: string;
  subtitle?: string;
  source?: string;
  status?: 'fresh' | 'stale' | 'partial';
  onExplain?: () => void;
  onViewData?: () => void;
  onViewSources?: () => void;
}) {
  return (
    <header className={styles.root}>
      <div>
        <span className={styles.meta}>
          {source && <SourceLabel source={source} />}
          <StatusBadge status={status}>{status}</StatusBadge>
        </span>
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className={styles.actions}>
        {onExplain && (
          <Button size="sm" variant="ghost" onClick={onExplain}>
            Explain this chart
          </Button>
        )}
        {onViewData && (
          <Button size="sm" variant="ghost" onClick={onViewData}>
            View data
          </Button>
        )}
        {onViewSources && (
          <Button size="sm" variant="ghost" onClick={onViewSources}>
            View sources
          </Button>
        )}
      </div>
    </header>
  );
}
